import type { License } from "@/lib/types";

export const licenses: License[] = [
  {
    id: "lic-svensk",
    slug: "svensk-licens",
    name_sv: "Svensk spellicens",
    name_en: "Swedish gambling license",
    jurisdiction: "Sverige",
    description_sv:
      "Svensk spellicens utfärdas av Spelinspektionen och är obligatorisk för casinon som riktar sig till spelare i Sverige. Licensen innebär anslutning till Spelpaus.se, krav på BankID, insättningsgränser, panik-knapp och tydlig svensk konsumenträtt.",
    description_en:
      "The Swedish gambling license is issued by Spelinspektionen and required for casinos targeting Swedish players. It mandates Spelpaus.se enrollment, BankID, deposit limits, a panic button and Swedish consumer protection rules.",
  },
  {
    id: "lic-mga",
    slug: "mga",
    name_sv: "MGA-licens (Malta)",
    name_en: "MGA license (Malta)",
    jurisdiction: "Malta",
    description_sv:
      "MGA-licens från Malta Gaming Authority är vanligt hos internationella casinon. Den ger ett rimligt konsumentskydd men ingår inte i det svenska Spelpaus-systemet.",
    description_en:
      "The MGA license from the Malta Gaming Authority is common with international casinos. It offers reasonable consumer protection but is not part of the Swedish Spelpaus system.",
  },
  {
    id: "lic-curacao",
    slug: "curacao",
    name_sv: "Curaçao-licens",
    name_en: "Curaçao license",
    jurisdiction: "Curaçao",
    description_sv:
      "Curaçao-licens har lägre krav än både svensk licens och MGA. Casinon med Curaçao kan ha lägre konsumentskydd och utbetalningar är inte garanterade på samma sätt.",
    description_en:
      "Curaçao licensing has lower requirements than both the Swedish license and MGA. Casinos under Curaçao can offer lower consumer protection and payouts are not guaranteed in the same way.",
  },
  {
    id: "lic-estonia",
    slug: "estland",
    name_sv: "Estnisk licens",
    name_en: "Estonian license",
    jurisdiction: "Estland",
    description_sv:
      "Estnisk licens utfärdas av Estonian Tax and Customs Board och är vanligt på pay-and-play sajter utan svensk licens.",
    description_en:
      "The Estonian license is issued by the Estonian Tax and Customs Board and common at pay-and-play sites without Swedish license.",
  },
  {
    id: "lic-ukgc",
    slug: "ukgc",
    name_sv: "UKGC-licens",
    name_en: "UKGC license",
    jurisdiction: "Storbritannien",
    description_sv:
      "UK Gambling Commission har strikta krav men gäller inte Sverige – brittisk licens säger inget om svensk konsumenträtt.",
    description_en:
      "The UK Gambling Commission has strict requirements but does not cover Sweden — a UK license says nothing about Swedish consumer protection.",
  },
];

export function findLicense(slug: string): License | undefined {
  return licenses.find((l) => l.slug === slug);
}
